export default "__VITE_ASSET__Cv3XWNB0__ 1200w";